
import React, { Component } from "react";
import moment from 'moment';
import { withStyles, Grid, Fade, CircularProgress, Typography, Divider, Hidden } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { Color } from "../../Constants";
import { makeStyles } from "@material-ui/core/styles";
import { DeliveryService } from "../../Services/DeliveryService";

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3)
    },
    tablecell: {
        fontSize: '30pt',
        padding: 2
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
        float: 'left'
    },
    section: {
		width: '100%',
		minHeight: 400,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        overflow: 'auto'
    }, 
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
    heading: {
        paddingLeft: theme.spacing(4),
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightRegular,
    },
  });

class UnAttendedStores extends Component {

    constructor(props) {
      super(props);
      this.state = {       
        startDate: moment(),
        endDate: moment(),
        showSpinner: false,
        status_rows: [],
      }
    }

    componentDidMount(){
        this.props.setTitle('Unattended Stores Report');
        this.setState({showSpinner: true}, () => this.fetchData());
    }

    handleChangeStartDate = (date) => {
        if(date !== this.state.startDate){
            this.setState({
                startDate: date,
            }, () => this.fetchData());
        }
    }

    fetchData = () => {
        let {startDate} = this.state;
        this.setState({showSpinner: true});
        let status_rows = [];

        DeliveryService.getUnattendedStoresList(startDate)
        .then((data) => {
            console.log(data);
            if(data.stores && data.stores.length > 0){
                data.stores.forEach((store, index) => {
                    status_rows.push(<StoreDetails index={index + 1} key={store.store_id} store={store} />);
                });
            }
            this.setState({showSpinner: false, status_rows, message: data.stores.length === 0 ? (data.deliveries_available ? "All stores were attended" : "No schedules available") : ""});
        })
        .catch(error => {
            console.log(error);
            this.setState({showSpinner: false, message: "Failed to fetch details. Check internet connection and retry."});
        });
    }
    
    render() {
        let { startDate, endDate, message, showSpinner, status_rows} = this.state;
        const { classes } = this.props;
        return ( 
            <div className="Home">
                <Paper className={classes.root} style={{paddingTop : 8, paddingLeft: "5px", paddingRight: "5px",minHeight: 250, marginTop: 32}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={2}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    variant="dialog"
                                    margin="normal"
                                    label="Schedule Date"
                                    value={startDate}
                                    onChange={this.handleChangeStartDate}
                                    format='DD MMM YYYY'
                                    maxDate={endDate}
                                    inputVariant="outlined"
                                    invalidDateMessage=""
                                    className={classes.formControl}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            
                        </Grid>
                        <Hidden mdDown>
                            <Grid item lg={6} md={6}>
                                <Typography align="left" className={classes.heading}>Store</Typography>
                            </Grid>
                        </Hidden>
                        <Hidden mdDown>
                            <Grid item lg={6} md={6}>
                                <Typography align="left" className={classes.heading}>Reason</Typography>
                            </Grid>
                        </Hidden>
                        <Grid item xs={12}>
                            {status_rows}
                            {message}
                        </Grid>
                    </Grid>
                    <Fade
                        key="spinner"
                        in={showSpinner}
                        style={{
                            transitionDelay: showSpinner ? '10ms' : '0ms',
                            position: 'absolute', left: '50%', top: '60%'
                        }}
                        unmountOnExit
                        >
                        <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                    </Fade>
                </Paper>
            </div>
        );
    }
}

const useStyles = makeStyles(theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
        textAlign: 'left'
    },
    subheading: {
        fontSize: theme.typography.pxToRem(16),
        textAlign: 'left'
    },
    grid:{
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(2),
    }
}));

function StoreDetails(props){

    const {store} = props;
    
    const classes = useStyles();
    
    return (
        <Grid container justify="flex-start" alignItems="center" direction="row" className={classes.grid}>
            <Hidden mdUp>
                <Grid item xs={6} lg={false} md={false} xl={false}>
                    <Typography className={classes.heading}>Store</Typography>
                </Grid>
            </Hidden>
            <Grid item xs={6} lg={6}>
                <Typography className={classes.subheading}>{store.store_name}</Typography>
            </Grid>
            <Hidden mdUp>
                <Grid item xs={6} lg={false} md={false} xl={false}>
                    <Typography className={classes.heading}>Reason</Typography>
                </Grid>
            </Hidden>
            <Grid item xs={6} lg={6}>
                <Typography className={classes.subheading} color={store.delivery_date ? "secondary" : "textSecondary"}>{store.delivery_date ? 'Marked as Undeliverable' : 'Not visited'}</Typography>
            </Grid>
            <Grid item xs={12} lg={12}>
                <Divider variant="fullWidth"/>
            </Grid>
        </Grid>
    );
}

export default withStyles(styles)(UnAttendedStores);